import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {UserSessionService} from '../auth/user-session.service';
import {Router} from '@angular/router';
import { DateUtils } from '../../utils/date-utils';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GlobalFiltersService {
    //private apiBase = 'https://erpapi.bnhl.in/InsightsAuthAPI/api';
    private endPoint = '/Dashboard/OPSHierarchy';
    private pageOutletInput = '';
    private filterChangeSubject = new Subject<any>();
    private controlsChangeSubject = new Subject<any>();
    private globalHeirarchyData = new Subject<any>();
    private $updateHierarchyStoreFilter = new Subject<any>();
    private heirarchyData: any;
    public outletData$ = new BehaviorSubject<any>(null);
    private globalFiltersData: {
        region: '';
        subRegion: '';
        cluster: '';
        city: '';
        outlet: '';
        session: '';
        toDate: '';
        fromDate: '';
        reportType: '';
        finYear: any;
        year: '';
        quarter: '',
        month: '';
        sType: '';
        rType: '';
        ssg: '';
        tillDate:'';
    };

    constructor(
        private http: HttpClient,
        private userdata: UserSessionService,
        private router: Router,
        private userSession: UserSessionService,
    ) {
        //this.apiBase = this.userdata.getApiBaseUrl();
    }

    fetchHeirarchyData(url, ssgFilter?, currDate?, currDate2?, typeOfUnit?, showActiveOnly?) {
        // Dynamic API (90001/OPSHierarchy); mapHierarchy rebuilds the legacy `Result` object.
        const dateUtils = new DateUtils();
        const headers = new HttpHeaders({Authorization:this.userSession.getAuthToken()});
        return this.http
            .post(environment.OPS_Dynamic_API_BASE_URL + '/90001/OPSHierarchy', {
                CurrentDate: currDate ? currDate : dateUtils.getDateWithOffset(-1),
                CurrentDate2: currDate2 ? currDate2 : dateUtils.getDateWithOffset(-1),
                SSG: ssgFilter ? ssgFilter : '',
                Menu: url,
                "TypeOfUnit": '',
                "Closed":'1,0',
                "Attribute": '',
                "CompanyId": '0',
                "FYear": ''
            }, {headers})
            .pipe(map(response => this.mapHierarchy(response)));
    }

    // Pick the resultset that has all of hasCols and none of notCols (empty sets are dropped).
    private findHierTable(res: any, hasCols: string[], notCols: string[] = []): any[] {
        for (const key of ['Table1','Table2','Table3','Table4','Table5','Table6','Table7','Table8','Table9','Table10']) {
            const t = res?.[key];
            if (Array.isArray(t) && t.length > 0) {
                const lk = Object.keys(t[0]).map(k => k.toLowerCase());
                if (hasCols.every(c => lk.includes(c.toLowerCase())) &&
                    notCols.every(c => !lk.includes(c.toLowerCase()))) return t;
            }
        }
        return [];
    }

    // Rebuild the legacy `Result` object; renames SubRegion->SubRegionName, CompanyID->CompanyId, AttributeName->Attribute.
    private mapHierarchy(res: any) {
        const rename = (rows: any[], from: string, to: string) =>
            (rows || []).map((r: any) => ({ ...r, [to]: r[from] }));
        return {
            Region: this.findHierTable(res, ['RegionName'], ['CityName','ClusterName','OutletCode','SubRegion','CompanyID','TypeOfUnit','AttributeName']),
            City: this.findHierTable(res, ['CityName'], ['OutletCode']),
            Cluster: rename(this.findHierTable(res, ['ClusterName'], ['OutletCode']), 'SubRegion', 'SubRegionName'),
            Outlet: rename(this.findHierTable(res, ['OutletCode']), 'SubRegion', 'SubRegionName'),
            SubRegion: rename(this.findHierTable(res, ['SubRegion','SubRegionID'], ['ClusterName','OutletCode']), 'SubRegion', 'SubRegionName'),
            Company: rename(this.findHierTable(res, ['CompanyID']), 'CompanyID', 'CompanyId'),
            TypeOfUnit: this.findHierTable(res, ['TypeOfUnit']),
            Attribute: rename(this.findHierTable(res, ['AttributeName']), 'AttributeName', 'Attribute'),
            Notification: res?.Notification,
        };
    }
    
setHeirarchyData(data) {
  this.heirarchyData = data;
  this.outletData$.next(data);   // update stream + store
  this.globalHeirarchyData.next(data);
}

    getHeirarchyData() {
        return this.globalHeirarchyData.asObservable();
    }

    getHeirarchyInfo() {
        return this.heirarchyData;
    }

    setData(filtersData) {
        this.globalFiltersData = filtersData;
    }

    fireChangeObservable() {
        this.filterChangeSubject.next(this.globalFiltersData);
    }

    getData() {
        return this.globalFiltersData;
    }

    enableControl(formName, defaultVal, option, show, skipMaxDate?) {
        this.controlsChangeSubject.next({
            fieldName: formName,
            defaultVal,
            option,
            visible: true,
            show,
            maxDate: skipMaxDate ? false : true
        });
    }

    disabledControl(formName) {
        this.controlsChangeSubject.next({fieldName: formName, visible: false});
    }

    resetControl(value) {
        this.controlsChangeSubject.next({fieldName: value, visible: false});
    }

    onControlChange() {
        return this.controlsChangeSubject.asObservable();
    }

    onFilterChange() {
        return this.filterChangeSubject.asObservable();
    }

    setInitialOutletValue(outletCode) {
        this.pageOutletInput = outletCode;
    }

    getInitialOutletValue() {
        return this.pageOutletInput;
    }

    resetPageInitials() {
        this.pageOutletInput = '';
    }

    onHierarchyStoreFilterChange(){
        return this.$updateHierarchyStoreFilter.asObservable();
    }

    changeHierarchyStoreFilter(typeOfUnit?, activeOnly?){
        this.$updateHierarchyStoreFilter.next({typeOfUnit:typeOfUnit,activeOnly:activeOnly});
    }
}
